import { render } from "./testimonial.vue?vue&type=template&id=766c2556"
import script from "./testimonial.vue?vue&type=script&lang=js"
export * from "./testimonial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__